import { t } from "ttag";
import _ from "underscore";

import { getShortStrategyLabel } from "metabase/admin/performance/utils";
import { getCollectionPathAsString } from "metabase/collections/utils";

import type { CacheableItem } from "./types";

/** Format an ISO timestamp for display in the cache history tables. Returns "-" when missing. */
export const formatDateTime = (value?: string | null) => {
  if (!value) {
    return "-";
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "-";
  }
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatValueForSorting = (
  row: CacheableItem,
  columnName: string,
) => {
  if (columnName === "policy") {
    const label = getShortStrategyLabel(row.strategy, row.model);
    if (row.strategy?.type === "duration") {
      // Sort durations in ascending order of length
      return label?.replace(/(\d+)h/, (_, num) => {
        const paddedNumber = num.padStart(5, "0");
        return `${t`Duration`} ${paddedNumber}`;
      });
    } else {
      return label;
    }
  }
  if (columnName === "auto_refresh") {
    return row.strategy?.type === "duration" ||
      row.strategy?.type === "schedule"
      ? row.strategy.refresh_automatically
      : false;
  }
  if (columnName === "refresh_status") {
    return row.refresh_status?.status ?? "";
  }
  if (columnName === "collection") {
    return row.collection ? getCollectionPathAsString(row.collection) : "";
  } else {
    return _.get(row, columnName);
  }
};
